module.exports = __webpack_public_path__ + "img/2.2f97f076.jpg";